import React, {PropTypes} from 'react';

const RichDescription = ({description}) => {
  return (
    <div
      className="event-description"
      dangerouslySetInnerHTML={{__html: description}} />
  );
};

// Note that this odd style is utilized for propType validation for now. Must be defined *after*
// the component is defined, which is why it's separate and down here.
RichDescription.propTypes = {
  description: PropTypes.string,
};

export default RichDescription;



/** WEBPACK FOOTER **
 ** ./src/components/common/RichDescription.js
 **/